import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from '../contents/ganttDiagram/Layout';
import SEO from '../components/seo';
import { Link } from 'gatsby';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = Layout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <SEO title="Gantt diagram builder" description="Create Gantt diagrams using simple code and integrate it in one click in Jira, Confluence, GitHub, Notion, and more." mdxType="SEO" />
    <h1>{`Gantt diagram `}<em parentName="h1">{`Build`}</em></h1>
    <pre><code parentName="pre" {...{
        "className": "language-gantt",
        "metastring": "copyable autoFocus",
        "copyable": true,
        "autoFocus": true
      }}>{`--- Task 1
   ====== Task 2
   -- Task 3
`}</code></pre>
    <p>{`Welcome to the online gantt diagram editor. You can `}<Link to="/gantt-diagram/learn" mdxType="Link">{`learn`}</Link>{` more
about gantt diagrams or read the syntax `}<Link to="/gantt-diagram/documentation" mdxType="Link">{`documentation`}</Link>{`.`}</p>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      